import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlogEntry } from './ubs-blog-model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
//import { StoreRootState } from '@urbannex/configuration/src/lib/router-store/route-state';
//import { StoreRootState } from '../../../node_modules/configuration/src/lib/router-store/route-state';
import { Store } from '@ngrx/store';
import { Meta, Title } from '@angular/platform-browser';
//import { ConfigurationService } from '@urbannex/blog/public-api';
import { ConfigurationService } from '@urbannex/configuration';
import { ColumnFieldTitle } from '@urbannex/ofbiz-forms';
//import { getRouterState } from '../../../node_modules/configuration/src/lib/router-store/selectors';
//import { getRouterState } from '@urbannex/configuration/src/lib/router-store/selectors';
//import { getRouterState } from '../../../node_modules/configuration/src/lib/router-store/selectors';

@Injectable({
  providedIn: 'root'
})
export class UbsBlogService {
  baseUrl:string;

  constructor(private http: HttpClient,
    private titleService: Title,
    private metaService:Meta,
    @Inject('configurationService') private configurationService:ConfigurationService,
    @Inject('env') private env,
    private route:ActivatedRoute) {
      //console.log(this.configurationService.selectEnv());
      this.baseUrl = env.apiUrl+"/";
      /* console.log(this.baseUrl);
      console.log(this.configurationService.selectWebSiteConfig());
      this.baseUrl = this.configurationService.getBaseUrl();
      console.log(this.baseUrl); */
    }

  getBlogEntries(blogContentId:string):Observable<BlogEntry[]>{
    console.log(blogContentId);
    //let url:string = this.baseUrl+'widgets/form/value/BlogEntries?location=component://kwikstore/widget/WebsiteContentForms.xml&blogContentId='+blogContentId;
    let url:string = this.baseUrl+'widgets/grid/value/BlogArticles?location=component://kwikstore/widget/WebsiteContentForms.xml';
    //let url:string = this.baseUrl+"getBlogEntriesList";
    let urlconfig = {"blogContentId":blogContentId};
    const options = { params: urlconfig,withCredentials:false };
    return this.http.get<any>(url,options)
      .pipe(
        map(resp => {
          //this.orderView = resp;
          return resp;
        })
      );
  }

  getBlogEntry(blogContentId:string,contentId:string):Observable<BlogEntry>{
    let url:string = this.baseUrl+"getBlogEntry";
    let urlconfig = {"contentId":contentId,"blogContentId":blogContentId};
    const options = { params: urlconfig,withCredentials:false };
    return this.http.get<any>(url,options)
      .pipe(
        map(resp => {
          //this.orderView = resp;
          return resp;
        })
      );
    }

  /* contentIdFromRoute():Observable<any>{
    return this.store.pipe(select(getRouterState),map(resp => {
      return resp
    }));
  } */

  setOGTags(tags:any[]){
    let titleTag = tags.find(tag => tag.name === "title");
    if(titleTag){
        this.titleService.setTitle(titleTag.content);
    }
    tags.forEach(tag => {
      if(tag.name){
        this.metaService.addTag({name:tag.name,content:tag.content});
      }else if(tag.property){
        this.metaService.addTag({property:tag.property,content:tag.content});
      }
    });

  }

  getBaseUrl(){
    return this.baseUrl;
  }

  getContentName(contentId:string):Observable<string>{
    let url:string = this.baseUrl+"getContentName";
    let urlconfig = {"contentId":contentId};
    const options = { params: urlconfig,withCredentials:false };
    return this.http.get<any>(url,options)
      .pipe(
        map(resp => {
          //this.orderView = resp;
          return resp;
        })
      );
  }

  /**
     * Function to generate fields given the name of the form (formName)
     * and FORMS (Array of forms)
     * @param formName 
     * @param FORMS 
     * @returns fields
     */
  getFields(formName:string,FORMS):any[]{
    let fields:any[];
    let columnFieldTitles:ColumnFieldTitle[];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if(localForm){
        fields = localForm.fields;
        columnFieldTitles = columnFieldTitles = localForm.columns;
        if(columnFieldTitles != undefined && columnFieldTitles.length > 0){
            //console.log("Found columnFieldTitles");
            fields.forEach(field => {
                let columnField = columnFieldTitles.find(element => element.name == field.name);
                if(columnField){
                    //console.log({FoundColumnField:{field:field.name,columnFieldTitle:columnField}})
                    field.title = columnField.title;
                }
            })
            
        }
    }
    return fields;
}
/**
 * @comment Function used to return column titles used in a table
 * @param formName Name of the form to look up
 * @param FORMS Array containing forms for this component
 * @returns columnFieldTitles
 */
getColumnFieldTitles(formName:string,FORMS:any[]):ColumnFieldTitle[]{
    let columnFieldTitles:any[];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if(localForm && localForm.columns){
        columnFieldTitles = localForm.columns;
    }
    console.log({columnFieldTitles:columnFieldTitles,"formName":formName});
    return columnFieldTitles
}

getTarget(formName:string,FORMS):string{
    let target = "";
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    target = localForm.target;
    return target;
}
getAltTarget(formName:string,FORMS):any[]{
    let altTargets = [];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    altTargets = localForm.altTarget;
    return altTargets;
}
/**
 * 
 * @param formName 
 * @param FORMS 
 * @returns targets object consisting of createTarget and EditTarget
 */
getTargets(formName:string,FORMS):any{
    let targets = {}
    let form = FORMS.find(form => form.name == formName || form.formName == formName);
    targets = form.targets;
    return targets
}
getAppContext(formName:string,FORMS):string{
    let form = FORMS.find(form => form.name == formName || form.formName == formName);
    let appContext = form.appContext || "";
    return appContext
}
/**
 * 
 * @param formName 
 * @param FORMS 
 * @returns The field name to be used when creating a title for the form
 */
getTitleDescriptionField(formName:string,FORMS):string{
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    let fieldName = localForm.titleDescriptionField ? localForm.titleDescriptionField : "";
    return fieldName;
}
getIdFieldName(formName:string,FORMS):string{
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    let fieldName = localForm.idFieldName ? localForm.idFieldName : "";
    return fieldName;
}


}
